import { Globals } from "../CoreApp/Globals";
export function appcstrp(strCode, plus) {
  return Globals._stringMgr.appcstr(strCode) + plus;
}
